export const locale = {
  lang: 'it',
  data: {
    TABLE: {
      ID: 'Id',
      SELLER_BUSINESS_NAME: 'Cedente',
      DEBTOR_BUSINESS_NAME: 'Debitore',
      INVOICE_NUMBER: 'Numero fattura',
      INVOICE_AMOUNT: 'Importo fattura',
    },
    ERROR: {
      REQUIRED: 'Campo obbligatorio',
      HIGH: 'Interesse troppo alto',
      WRONG_TRANSACTION_PASSWORD: 'Password dispositiva errata',
    },
    MASSIVE_BID: {
      TITLE: 'Acquisto massivo',
      FUND: 'Fondo',
      VIRTUAL_BALANCE: 'Saldo disponibile',
      TOTAL_DOWN_PAYMENT: 'Totale acconti',
      ALERT_INSUFFICIENT_LIQUIDITY: 'Attenzione! La liquidità sul conto non è sufficiente per pagare gli acconti di tutte le aste selezionate. Contattare il team CashMe per ulteriori chiarimenti o effettuare un bonifico per garantire la liquidità sufficiente.',
      MASTER_RATE: 'Interesse mensile',
      APPLY_TO_ALL: 'Applica a tutte',
      MASTER_RATE_HINT: 'Il tasso può essere modificato asta per asta nella tabella.',
      DOWN_PAYMENT: 'Acconto',
      MAX_RATE: 'Tasso attuale',
      BID_RATE: 'Tua offerta',
      DOWNLOAD_CONDITIONS: 'Scarica le Condizioni della Cessione',
      IAS_COMPLIANT_INVOICE: 'Cessione IAS Compliant: il tasso non è modificabile',
      TRANSACTION_PASSWORD: 'Password dispositiva',
      TOS_1: 'Confermo di conoscere e accetto i ',
      TOS_1_LINK: '"Termini e Condizioni di Utilizzo della Piattaforma"',
      TOS_2: 'Confermo di conoscere e accetto le "Condizioni della Cessione" di ciascuna asta selezionata, che ho scaricato e verificato.',
      TOS_3:
        'Accetto che il pagamento del Credito da parte del Debitore Ceduto verrà effettuato sul conto corrente bancario intestato ' +
        'all\'Istituto di Pagamento, il quale provvederà prontamente a trasferire il relativo incasso sul Conto di Pagamento del Cessionario, ' +
        'al netto del Saldo dovuto al Cedente.',
      TOS_4:
        'Accetto che CashMe, a seguito dell\'incasso di ciascun Credito da parte del l\'Istituto di Pagamento, provveda a calcolare ' +
        'l\'importo del Saldo e che l\'Istituto di pagamento stesso provveda ad utilizzare parte dell\'incasso per procedere al pagamento ' +
        'del Saldo dovuto direttamente a favore del Cedente ad eccezione delle cessioni IAS Compliant.',
      SEND: 'Invia {{count}} offerte',
      CANCEL: 'Annulla',
      CLOSE: 'Chiudi',
      RESULT_SUMMARY: '{{success}} offerte inviate su {{total}}',
      OUTCOME: 'Esito',
      OUTCOME_SUCCESS: 'Offerta inviata',
      ERROR: {
        GENERAL: 'Errore: offerte non inviate. Riprova.',
        BETTER_OFFER_EXISTS: 'Esiste già un\'offerta migliore',
        RATE_ABOVE_MAX: 'Interesse superiore al massimo consentito',
        SAME_BUYER: 'Non è possibile rilanciare sulla propria offerta',
        AUCTION_SOLD: 'Asta già aggiudicata',
        AUCTION_NOT_ACTIVE: 'Asta non ancora iniziata o già scaduta',
        ZERO_BID: 'Offerta a valore zero',
        RATE_BELOW_MIN: 'Interesse inferiore al minimo consentito',
        MAX_BID_INVALID: 'Offerta massima non valida',
        WRONG_BUYER: 'Asta non disponibile per questo buyer',
        WRONG_FUND: 'Fondo non valido',
      },
    },
  },
};
